module.exports = __webpack_public_path__ + "static/media/tech.741bb8d5.svg";